import get from "lodash.get";

// used to parse response from the /profiles endpoint which has format of {pool:{solicitor}}

export const isLeadVol = pool => get(pool, "solicitor.role", "") === "Volunteer Lead";
